import React from 'react';
import "./Buttons.scss";

interface IButton extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
    children: any
}

function Button({ children, ...props }: IButton) {
    const {className, ...restProps} = props
    return (
        // eslint-disable-next-line react/button-has-type
        <button className={`Button ${className || ""}`} {...restProps}>{children}</button>
    )
}


export default Button